module.exports = __webpack_public_path__ + "static/img/汽车.4d70839.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/system/assets/汽车.png
// module id = rJ72
// module chunks = 3